<template>
    <kt-row style="padding-right: 25px;display: block" v-if="form_data">
        <form id="open_banking_bank_withdrawal_limits_settings_form">
            <div v-for="(bank,index) in form_data" v-bind:key="index">
                <kt-row>
                    <kt-col lg="3" md="5" sm="6" xs="12" style="margin-top: 34px">
                        <p>
                            {{ bankIdStr.get(index) }}
                        </p>
                    </kt-col>
                    <kt-col lg="9" md="7" sm="6" xs="12">
                        <div v-for="(withdraw_type, withdraw_index) in bankTransferTransactionType"
                             v-bind:key="withdraw_index">
                            <kt-row>
                                <kt-col lg="4" md="4" sm="4" xs="6">
                                    <kt-form-group ref="withdraw_type">
                                        <kt-form-label for="withdraw_type" v-show="withdraw_type === 1">
                                            {{ $t('label.withdraw_type') }}
                                        </kt-form-label>
                                        <kt-form-control
                                            :value="bankTransferTransactionTypeStr.get(withdraw_type)"
                                            disabled
                                            :id="withdraw_index"></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="4" md="4" sm="4" xs="6">
                                    <kt-form-group ref="min">
                                        <kt-form-label for="min" v-show="withdraw_type === 1">
                                            {{ $t('label.min') + $t('label.rial_in_parenthesis') }}
                                        </kt-form-label>
                                        <kt-form-control
                                            v-model="form_data[index][withdraw_type].min"
                                            :name="index+'_'+withdraw_type+'_min'"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col lg="4" md="4" sm="4" xs="6">
                                    <kt-form-group ref="max">
                                        <kt-form-label for="max" v-show="withdraw_type === 1">
                                            {{ $t('label.max') + $t('label.rial_in_parenthesis') }}
                                        </kt-form-label>
                                        <kt-form-control
                                            v-model="form_data[index][withdraw_type].max"
                                            :name="index+'_'+withdraw_type+'_max'"
                                        ></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                            </kt-row>
                        </div>
                    </kt-col>
                </kt-row>
                <hr>
            </div>
            <kt-form-action class="mt-4">
                <kt-button
                    class="m-2"
                    size="md"
                    variant="success"
                    type="button"
                    @click="updateSettings"
                    id="submit_btn_open_banking_bank_withdrawal_limits_settings"
                >
                    {{ $t('btn.update') }}
                </kt-button>
            </kt-form-action>
        </form>
    </kt-row>
</template>

<script>
import $ from "jquery"
import {KTApp} from '@/plugins/core/app'
import {openBankingService} from '@/common/api.service'
import {bankIdStr} from '@/constants/bankId'
import {
    bankTransferTransactionType,
    bankTransferTransactionTypeStr
} from '@/constants/bankTransferTransaction'
import {i18n} from '@/plugins/i18n'
import {KTUtil} from "@/plugins/core/util";

export default {
    name: "BankWithdrawalLimitsSettings",

    data() {
        return {
            form_data: {},
            bankIdStr,
            bankTransferTransactionType,
            bankTransferTransactionTypeStr,
        }
    },
    mounted() {
        openBankingService.getBankWithdrawalLimitsSettings().then(response => {
            this.form_data = response.data.data.data

        }).catch(({response}) => {
            this.showMsg(form, 'danger', response.data.message)
        })
    },
    methods: {
        updateSettings() {
            let form = $('#open_banking_bank_withdrawal_limits_settings_form')
            let btn = $('#submit_btn_open_banking_bank_withdrawal_limits_settings')
            let rules = {};
            Object.keys(this.form_data).forEach(bank => {
                Object.values(this.bankTransferTransactionType).forEach(type => {
                    rules[bank + '_' + type + '_min'] = {required: true};
                    rules[bank + '_' + type + '_max'] = {required: true};
                });
            })

            form.validate({
                rules: rules,
                invalidHandler: function (form, validator) {
                    console.log('Validation errors:');
                    $.each(validator.errorList, function (index, error) {
                        console.log(error.message + ' for element: ' + error.element.name);
                    });

                    console.log('Validator object:', validator);
                },
            })
            if (!form.valid()) {
                return this.toastr.error(i18n.t('open_banking.message.fill_all'))
            }
            KTApp.progress(btn)

            openBankingService.updateBankWithdrawalLimitsSettings(this.form_data).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                    KTApp.unprogress(btn)
                    KTUtil.scrollTop();
                }
            );
        },
    },
}
</script>

<style scoped>

</style>
